export enum OverviewBannerStatus {
  ALL_PREPARED = 'all-prepared',
  DEFAULT = 'default',
  DOCUMENT_UPLOADED = 'document-uploaded',
  DOCUMENT_UPLOADED_BEFORE_APPOINTMENT = 'document-uploaded-before-appointment',
  FRESH_START = 'fresh-start',
  KNOWLEDGE_TEST = 'knowledge-test',
  MAKE_APPOINTMENT = 'make-appointment',
  PARTNER_MUST_SIGN_OFFER = 'partner-must-sign-offer',
  SIGN_OFFER = 'sign-offer',
  SIGN_OFFER_DONE = 'sign-offer-done',
  START_CALCULATION = 'start-calculation',
  WAIT = 'wait'
}

export enum RevisionBannerStatus {
  IN_PROGRESS = 'in-progress',
  READY_FOR_INTERVIEW = 'ready-for-interview',
  STAY_IN_TOUCH = 'stay-in-touch',
  SUBMIT_DOCUMENTS = 'submit-documents',
  SUBMIT_REVISION_FORM = 'submit-revision-form',
  SUMMARY_TO_DO = 'summary-to-do',
  WELCOME = 'welcome'
}
